import React from 'react';

import PropTypes from 'prop-types';

import Button, { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import { pluginShape } from '../helpers/propTypes';

const EntityPickerModalFooter = ({
  plugin,
  multiple,
  isSaving,
  createPanelOpen,
  selectedEntities,
  clearSelection,
  closeModal,
  onSave,
  saveButtonText,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const selectedEntitiesCount = selectedEntities.length;

  return (
    <>
      <div
        css={[
          {
            display: 'flex',
            alignItems: 'center',
          },
        ]}
      >
        {multiple && selectedEntitiesCount > 0 && (
          <>
            {plugin ? (
              <span
                css={[
                  {
                    color: theme.colors.charcoal700,
                  },
                ]}
              >
                <plugin.SelectedCount
                  count={selectedEntitiesCount}
                  multiple={multiple}
                />
              </span>
            ) : null}
            <LinkButton
              onClick={clearSelection}
              disabled={isSaving || createPanelOpen}
              style={{
                marginLeft: 8,
              }}
            >
              {T.translate('CLEAR')}
            </LinkButton>
          </>
        )}
      </div>
      <div>
        <Button
          variant={Button.VARIANTS.TERTIARY}
          onClick={closeModal}
          disabled={isSaving}
          style={{
            marginRight: 8,
          }}
        >
          {T.translate('CANCEL')}
        </Button>
        <Button
          variant={Button.VARIANTS.PRIMARY}
          onClick={() =>
            onSave(multiple ? selectedEntities : selectedEntities[0])
          }
          disabled={isSaving || !selectedEntitiesCount || createPanelOpen}
          loading={isSaving}
        >
          {saveButtonText ? (
            saveButtonText
          ) : plugin ? (
            <plugin.AddRelationshipsButtonText
              count={selectedEntitiesCount}
              multiple={multiple}
            />
          ) : (
            ''
          )}
        </Button>
      </div>
    </>
  );
};

EntityPickerModalFooter.propTypes = {
  /**
   * The plugin to use for selected entity type.
   */
  plugin: pluginShape,
  /**
   * Whether the component is multi selectable.
   */
  multiple: PropTypes.bool,
  /**
   * Save button click handler.
   * Shape: (selectedEntities) => *
   */
  onSave: PropTypes.func,
  /**
   * Whether we're currently in saving process.
   */
  isSaving: PropTypes.bool,
  /**
   * Whether create panel is currently open.
   */
  createPanelOpen: PropTypes.bool,
  /**
   * List of selected entities.
   */
  selectedEntities: PropTypes.array,
  /**
   * A handle method to clear current selection.
   */
  clearSelection: PropTypes.func,
  /**
   * A handle method to close the modal.
   */
  closeModal: PropTypes.func,
  /**
   * Save button text.
   */
  saveButtonText: PropTypes.node,
};

export default EntityPickerModalFooter;
